module.exports = __webpack_public_path__ + "img/ap32-landing2-bg.3a87c9db.png";